/**
 * Reads a CSS custom property value from the document root element.
 *
 * @param name - The CSS variable name including the `--` prefix (e.g. `--mi-primary-main`).
 * @returns The trimmed computed value of the CSS variable.
 */
export function getCssVar(name: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
